import React, { useEffect, useState } from 'react'
import { ArrowFatDown, ArrowFatUp, Trash, Eye } from '@phosphor-icons/react'
import ModalDeleteProject from './ModalDeleteProject'
import { formatDateTime, toast } from '../utils'

const ProjectsList = ({
  projects_path,
  project_path,
  projects,
  onSearchResults,
  onProjectDelete,
}) => {
  const [open, setOpen] = useState(false)
  const [project, setProject] = useState(null)
  const [sort, setSort] = useState('created_at')
  const [direction, setDirection] = useState('asc')
  const [viewingField, setViewingField] = useState(null)
  
  const handleProjectSearch = async () => {
  
    try {
      const response = await fetch(
        `${projects_path}?sort=${sort}&direction=${direction}`, {
          headers: {
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').
              getAttribute('content'),
            'Accept': 'application/json',
          },
        })

      if (response.ok) {
        const projects = await response.json()
        onSearchResults(projects)
      }
    } catch (error) {
      console.error('Error fetching contents:', error)
    }
  }
  useEffect(() => {
    handleProjectSearch()
  }, [sort, direction])

  const handleProjectDelete = async () => {
    try {
      const response = await fetch(`/projects/${project?.id}`, {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').
            getAttribute('content'),
          'Accept': 'application/json',
        },
      })

      if (response.ok) {
        setOpen(false)
        setProject(null)
        onProjectDelete(project)
        toast({message: 'Project deleted successfully', type: 'success', duration: 3000, gravity: 'top', position: 'right'})
      }
    } catch (error) {
      console.error('Error deleting project:', error)
      setOpen(false)
      setProject(null)
    }
  }

  const openDeleteModal = (project) => {
    setProject(project)
    setOpen(true)
  }

  const handleViewClick = (field, value) => {
    if (viewingField === field) {
      setViewingField(null)
    } else {
      setViewingField(field)
    }
  }

  return (
    <div className="overflow-x-auto h-96">
      <ModalDeleteProject open={open} onClose={() => setOpen(false)}
                          onDelete={handleProjectDelete} project={project}/>
      <table
        className="table table-pin-rows table-zebra border-b-2 border-gray-200">
        <thead>
        <tr>
          <th onClick={() => {
            setSort('name')
            setDirection(direction === 'asc' ? 'desc' : 'asc')
          }}>
            <div className="flex flex-row items-center gap-2 link link-hover">
              <label>
                Name
              </label>
              <div>
                {direction === 'desc' ? <ArrowFatDown size={16} weight="fill"
                                                      color="teal"/> :
                  <ArrowFatUp size={16} weight="fill" color="teal"/>}
              </div>
            </div>
          </th>
          <th onClick={() => {
            setSort('contents_count')
            setDirection(direction === 'asc' ? 'desc' : 'asc')
          }}>
            <div className="flex flex-row items-center gap-2 link link-hover">
              <label>
                Contents
              </label>
              <div>
                {direction === 'desc' ? <ArrowFatDown size={16} weight="fill"
                                                      color="teal"/> :
                  <ArrowFatUp size={16} weight="fill" color="teal"/>}
              </div>
            </div>
          </th>
          <th onClick={() => {
            setSort('webhook_token')
            setDirection(direction === 'asc' ? 'desc' : 'asc')
          }}>
            <div className="flex flex-row items-center gap-2 link link-hover">
              <label>
                Webhook?
              </label>
              <div>
                {direction === 'desc' ? <ArrowFatDown size={16} weight="fill"
                                                      color="teal"/> :
                  <ArrowFatUp size={16} weight="fill" color="teal"/>}
              </div>
            </div>
          </th>
          <th onClick={() => {
            setSort('email_address')
            setDirection(direction === 'asc' ? 'desc' : 'asc')
          }}>
            <div className="flex flex-row items-center gap-2 link link-hover">
              <label>
                Email?
              </label>
              <div>
                {direction === 'desc' ? <ArrowFatDown size={16} weight="fill"
                                                      color="teal"/> :
                  <ArrowFatUp size={16} weight="fill" color="teal"/>}
              </div>
            </div>
          </th>
          <th onClick={() => {
            setSort('api_key')
            setDirection(direction === 'asc' ? 'desc' : 'asc')
          }}>
            <div className="flex flex-row items-center gap-2 link link-hover">
              <label>
                Api?
              </label>
              <div>
                {direction === 'desc' ? <ArrowFatDown size={16} weight="fill"
                                                      color="teal"/> :
                  <ArrowFatUp size={16} weight="fill" color="teal"/>}
              </div>
            </div>
          </th>
          <th onClick={() => {
            setSort('public_project_token')
            setDirection(direction === 'asc' ? 'desc' : 'asc')
          }}>
            <div className="flex flex-row items-center gap-2 link link-hover">
              <label>
                Public Project Page?
              </label>
              <div>
                {direction === 'desc' ? <ArrowFatDown size={16} weight="fill"
                                                      color="teal"/> :
                  <ArrowFatUp size={16} weight="fill" color="teal"/>}
              </div>
            </div>
          </th>
          <th onClick={() => {
            setSort('created_at')
            setDirection(direction === 'asc' ? 'desc' : 'asc')
          }}>
            <div className="flex flex-row items-center gap-2 link link-hover">
              <label>
                Created At
              </label>
              <div>
                {direction === 'desc' ? <ArrowFatDown size={16} weight="fill"
                                                      color="teal"/> :
                  <ArrowFatUp size={16} weight="fill" color="teal"/>}
              </div>
            </div>
          </th>
          <th>Actions</th>
        </tr>
        </thead>
        <tbody>
        {projects?.map((project) => (
          <tr key={project?.id} className="hover">

            <td>
              <a
                className="link link-hover"
                href={project_path?.replace(':id', project?.id)}>
                {project?.name}
              </a>
            </td>
            <td>
              <a
                className="link link-hover"
                href={project_path?.replace(':id', project?.id)}>
                {project?.contents_count}
              </a>
            </td>
            <td>
              {project?.webhook_token ? (
                <div className="group/cell">
                  {viewingField === `webhook_${project.id}` ? (
                    <span>{project.webhook_token}</span>
                  ) : (
                    <>
                      <span className="group-hover/cell:hidden">Yes</span>
                      <button 
                        className="btn btn-xs btn-outline hidden group-hover/cell:inline-flex"
                        onClick={() => handleViewClick(`webhook_${project.id}`, project.webhook_token)}
                      >
                        <span className="hidden group-hover/cell:inline-flex">View</span>
                        <Eye size={14}/>
                      </button>
                    </>
                  )}
                </div>
              ) : 'No'}
            </td>
            <td>
              {project?.email_address ? (
                <div className="group/cell">
                  {viewingField === `email_${project.id}` ? (
                    <span>{project.email_address}</span>
                  ) : (
                    <>
                      <span className="group-hover/cell:hidden">Yes</span>
                      <button 
                        className="btn btn-xs btn-outline hidden group-hover/cell:inline-flex"
                        onClick={() => handleViewClick(`email_${project.id}`, project.email_address)}
                      >
                        <span className="hidden group-hover/cell:inline-flex">View</span>
                        <Eye size={14}/>
                      </button>
                    </>
                  )}
                </div>
              ) : 'No'}
            </td>
            <td>
              {project?.api_key ? (
                <div className="group/cell">
                  {viewingField === `api_${project.id}` ? (
                    <span>{project.api_key}</span>
                  ) : (
                    <>
                      <span className="group-hover/cell:hidden">Yes</span>
                      <button 
                        className="btn btn-xs btn-outline hidden group-hover/cell:inline-flex"
                        onClick={() => handleViewClick(`api_${project.id}`, project.api_key)}
                      >
                        <span className="hidden group-hover/cell:inline-flex">View</span>
                        <Eye size={14}/>
                      </button>
                    </>
                  )}
                </div>
              ) : 'No'}
            </td>
            <td>
              {project?.public_project_token ? (
                <div className="group/cell">
                  {viewingField === `public_project_token_${project.id}` ? (
                    <span>{project.public_project_token}</span>
                  ) : (
                    <>
                      <span className="group-hover/cell:hidden">Yes</span>
                      <button 
                        className="btn btn-xs btn-outline hidden group-hover/cell:inline-flex"
                        onClick={() => handleViewClick(`public_project_token_${project.id}`, project.public_project_token)}
                      >
                        <span className="hidden group-hover/cell:inline-flex">View</span>
                        <Eye size={14}/>
                      </button>
                    </>
                  )}
                </div>
              ) : 'No'}
            </td>
            <td>{formatDateTime(project?.created_at)}</td>

            <td>
              <div className="flex gap-2">
                <button className="btn btn-xs btn-error btn-outline"
                        onClick={() => openDeleteModal(project)}>
                  <Trash size={14}/>
                </button>
              </div>
            </td>
          </tr>
        ))}
        </tbody>
      </table>
    </div>
  )
}

export default ProjectsList